import React from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Toggle from "../../../controls/Toggle";
import { setModRequirementsEnabled } from "../actions/persistent";
import { isModRequirementsEnabled } from "../selectors";
const SettingsHealthCheck = () => {
    const { t } = useTranslation(["health_check"]);
    const dispatch = useDispatch();
    const enabled = useSelector(isModRequirementsEnabled);
    const onToggle = React.useCallback(() => {
        dispatch(setModRequirementsEnabled(!enabled));
    }, [dispatch, enabled]);
    return (React.createElement("form", null,
        React.createElement(FormGroup, { controlId: "health-check-settings" },
            React.createElement(ControlLabel, null, t("settings::title")),
            React.createElement(HelpBlock, null, t("settings::description")),
            React.createElement(Toggle, { checked: enabled, onToggle: onToggle }, t("settings::mod_requirements")))));
};
export default SettingsHealthCheck;
